webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(13),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Quiz__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Quiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Quiz__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Quiz: __WEBPACK_IMPORTED_MODULE_0__components_Quiz___default.a
  },
  data: function data() {
    return {
      startedQuiz: false,
      questions: [{
        name: '10 mL Cylinder',
        total: 10,
        uncertainty: 0.05,
        volume: '9.23',
        options: ['9.23', '9.2', '9.245'],
        zoom: 'cylinder-9-23-zoom.svg',
        cylinder: 'cylinder-9-23.svg'
      }, {
        name: '10 mL Cylinder',
        total: 10,
        uncertainty: 0.05,
        volume: '0.75',
        options: ['0.7', '0.750', '0.75'],
        zoom: 'cylinder-075-zoom.svg',
        cylinder: 'cylinder-075.svg'
      }, {
        name: '10 mL Cylinder',
        total: 10,
        uncertainty: 0.05,
        volume: '3.67',
        options: ['3.6', '3.701', '3.67'],
        zoom: 'cylinder-3-67-zoom.svg',
        cylinder: 'cylinder-3-67.svg'
      }, {
        name: '10 mL Cylinder',
        total: 10,
        uncertainty: 0.05,
        volume: '5.16',
        options: ['5.2', '5.16', '5.159'],
        zoom: 'cylinder-5-16-zoom.svg',
        cylinder: 'cylinder-5-16.svg'
      }, {
        name: '10 mL Cylinder',
        total: 10,
        uncertainty: 0.05,
        volume: '7.48',
        options: ['7.481', '7.4', '7.48'],
        zoom: 'cylinder-7-48-zoom.svg',
        cylinder: 'cylinder-7-48.svg'
      }, {
        name: '100 mL Cylinder',
        total: 100,
        uncertainty: 0.5,
        volume: '42.7',
        options: ['42', '42.7', '42.75'],
        zoom: 'cylinder-42-7-zoom.svg',
        cylinder: 'cylinder-42-7.svg'
      }, {
        name: '100 mL Cylinder',
        total: 100,
        uncertainty: 0.5,
        volume: '6.2',
        options: ['6.25', '6.2', '6.208'],
        zoom: 'cylinder-6-2-zoom.svg',
        cylinder: 'cylinder-6-2.svg'
      }, {
        name: '100 mL Cylinder',
        total: 100,
        uncertainty: 0.5,
        volume: '94.7',
        options: ['94.7', '94', '94.75'],
        zoom: 'cylinder-94-7-zoom.svg',
        cylinder: 'cylinder-94-7.svg'
      }, {
        name: '100 mL Cylinder',
        total: 100,
        uncertainty: 0.5,
        volume: '19.5',
        options: ['19', '19.5', '19.55'],
        zoom: 'cylinder-19-5-zoom.svg',
        cylinder: 'cylinder-19-5.svg'
      }, {
        name: '100 mL Cylinder',
        total: 100,
        uncertainty: 0.5,
        volume: '68.0',
        options: ['68.00', '68.0', '68'],
        zoom: 'cylinder-68-zoom.svg',
        cylinder: 'cylinder-68.svg'
      }, {
        name: '1000 mL Cylinder',
        total: 1000,
        uncertainty: 5,
        volume: '748',
        options: ['748.0', '748', '748.25'],
        zoom: 'cylinder-748-zoom.svg',
        cylinder: 'cylinder-748.svg'
      }, {
        name: '1000 mL Cylinder',
        total: 1000,
        uncertainty: 5,
        volume: '225',
        options: ['225', '225.50', '225.5'],
        zoom: 'cylinder-225-zoom.svg',
        cylinder: 'cylinder-225.svg'
      }, {
        name: '1000 mL Cylinder',
        total: 1000,
        uncertainty: 5,
        volume: '883',
        options: ['883.25', '883.2', '883'],
        zoom: 'cylinder-883-zoom.svg',
        cylinder: 'cylinder-883.svg'
      }, {
        name: '1000 mL Cylinder',
        total: 1000,
        uncertainty: 5,
        volume: '50.',
        options: ['50.0', '50.', '50.00'],
        zoom: 'cylinder-50-zoom.svg',
        cylinder: 'cylinder-50.svg'
      }, {
        name: '1000 mL Cylinder',
        total: 1000,
        uncertainty: 5,
        volume: '451',
        options: ['451', '451.5', '451.75'],
        zoom: 'cylinder-451-zoom.svg',
        cylinder: 'cylinder-451.svg'
      }]
    };
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quiz',
  data: function data() {
    return {
      debug: false,
      totalQuestions: 10,
      guessVolume: [],
      guessUncertainty: [],
      currentQindex: 0,
      currentScore: 0,
      randomQuestions: [],
      halfStep: false,
      firstWrong: false,
      secondWrong: false,
      finalStep: false,
      isLooking: []
    };
  },
  props: ['questions', 'startedQuiz'],
  methods: {
    lookOn: function lookOn(index) {
      // there has to be a better way to do this... but this works ¯\_(ツ)_/¯
      var a = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.isLooking));a[index] = true; // what?
      this.$set(this, 'isLooking', a); // use Vue.set so the dom responds
    },
    lookOff: function lookOff(index) {
      var a = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.isLooking));a[index] = false; // ok!
      this.$set(this, 'isLooking', a);
    },
    submitAnswer: function submitAnswer() {
      var Qi = this.currentQindex;
      var answerVolume = this.randomQuestions[Qi].volume;
      var guessVolume = this.guessVolume[Qi];

      if (!guessVolume) {
        alert('Please select a volume');return;
      }

      if (guessVolume === answerVolume) {
        this.currentScore++;
        this.$set(this, 'halfStep', true);
      } else {
        this.$set(this, 'firstWrong', true);
      }
    },
    continueWrong: function continueWrong() {
      this.$set(this, 'halfStep', true);
    },
    submitUncertainty: function submitUncertainty() {
      var Qi = this.currentQindex;
      var answerUncertainty = parseFloat(this.randomQuestions[Qi].uncertainty);
      var guessUncertainty = parseFloat(this.guessUncertainty[Qi]);

      if (!guessUncertainty) {
        alert('Please specify a numerical uncertainty value');return;
      }

      if (guessUncertainty === answerUncertainty) {
        this.currentScore++;
      } else {
        this.$set(this, 'secondWrong', true);
      }
      this.$set(this, 'finalStep', true);
    },
    nextQuestion: function nextQuestion() {
      this.halfStep = false;
      this.finalStep = false;
      this.firstWrong = false;
      this.secondWrong = false;
      this.currentQindex++;
    },
    checkVolumeGuess: function checkVolumeGuess(e) {
      if (this.firstWrong === true) {
        return false;
      } // already guessed, get out!

      var Qi = this.currentQindex;
      var guessVolume = this.guessVolume[Qi];
      var answerVolume = this.randomQuestions[Qi].volume;

      var opts = document.querySelectorAll('.guess-option_' + Qi + ' input');
      var i;
      for (i = 0; i < opts.length; i++) {
        opts[i].classList.remove('incorrect', 'correct');
        if (opts[i].value === answerVolume) {
          opts[i].classList.add('correct');
        }
      }

      if (answerVolume !== guessVolume) {
        e.target.classList.add('incorrect');
      }
    },
    resetEverything: function resetEverything() {
      this.currentQindex = 0;
      this.currentScore = 0;
      this.guessVolume = [];
      this.guessUncertainty = [];
      this.halfStep = false;
      this.finalStep = false;
      this.firstWrong = false;
      this.secondWrong = false;
      this.$emit('restartQuiz'); // tell the parent component we're restarting too
      this.randomizeQuestions();
    },
    randomizeQuestions: function randomizeQuestions() {
      var array = this.questions;
      var currentIndex = array.length;
      var temporaryValue, randomIndex;
      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      this.randomQuestions = array.slice(0, this.totalQuestions);
      this.halfStep = false;
    }
  },
  created: function created() {
    this.randomizeQuestions();
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(12),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a53c9f7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex < _vm.totalQuestions),
      expression: "currentQindex < totalQuestions"
    }],
    attrs: {
      "id": "score"
    }
  }, [_vm._v("\n    question " + _vm._s(_vm.currentQindex + 1) + " / " + _vm._s(_vm.totalQuestions) + "     score " + _vm._s(_vm.currentScore) + " / " + _vm._s(_vm.totalQuestions * 2) + "\n  ")]), _vm._v(" "), _vm._l((_vm.randomQuestions), function(q, index) {
    return _c('div', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.currentQindex),
        expression: "index === currentQindex"
      }]
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.debug === true),
        expression: "debug === true"
      }],
      staticClass: "debug"
    }, [_vm._v("\n        (DEBUGGING - ANSWERS SHOWN)"), _c('br'), _vm._v("\n        volume: " + _vm._s(q.volume)), _c('br'), _vm._v("\n        uncertainty: " + _vm._s(q.uncertainty)), _c('br'), _vm._v("\n        cylinder total: " + _vm._s(q.total)), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "question"
    }, [_c('div', {
      staticClass: "cylinder",
      class: {
        looking: _vm.isLooking[index]
      }
    }, [_c('button', {
      staticClass: "btn alt",
      on: {
        "click": function($event) {
          _vm.lookOn(index)
        }
      }
    }, [_vm._v("Get a closer look")]), _vm._v(" "), _c('img', {
      attrs: {
        "src": 'static/' + q.cylinder,
        "alt": q.name,
        "width": "126",
        "height": "511"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "closer-look"
    }, [_c('img', {
      attrs: {
        "src": 'static/' + q.zoom,
        "alt": q.name + ' zoom',
        "width": "316",
        "height": "316"
      }
    }), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.lookOff(index)
        }
      }
    }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.halfStep === false && _vm.finalStep === false),
        expression: "halfStep === false && finalStep === false"
      }],
      staticClass: "guesses",
      class: {
        neutral: !_vm.firstWrong, wrong: _vm.firstWrong
      }
    }, [_c('p', {
      staticClass: "neutral"
    }, [_vm._v("Select the most accurate volume.")]), _vm._v(" "), _c('p', {
      staticClass: "wrong"
    }, [_vm._v("Incorrect! But, you can still earn a point by determining the uncertainty value for the correct measurement.")]), _vm._v(" "), _vm._l((q.options), function(o, i) {
      return _c('div', {
        staticClass: "guess-option",
        class: 'guess-option_' + index
      }, [_c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.guessVolume[index]),
          expression: "guessVolume[index]"
        }],
        attrs: {
          "name": index + '_guess-option',
          "id": index + '_' + i,
          "type": "radio",
          "disabled": _vm.firstWrong === true,
          "autocomplete": "off"
        },
        domProps: {
          "value": o,
          "checked": _vm._q(_vm.guessVolume[index], o)
        },
        on: {
          "change": _vm.checkVolumeGuess,
          "__c": function($event) {
            _vm.$set(_vm.guessVolume, index, o)
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": index + '_' + i
        }
      }, [_vm._v(_vm._s(o) + " mL")])])])
    }), _vm._v(" "), _c('button', {
      staticClass: "guess btn neutral",
      on: {
        "click": _vm.submitAnswer
      }
    }, [_vm._v("Submit Answer")]), _vm._v(" "), _c('button', {
      staticClass: "guess btn wrong",
      on: {
        "click": _vm.continueWrong
      }
    }, [_vm._v("Continue")])], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.halfStep === true && _vm.finalStep === false),
        expression: "halfStep === true && finalStep === false"
      }],
      staticClass: "guesses"
    }, [_c('p', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.firstWrong === false),
        expression: "firstWrong === false"
      }]
    }, [_vm._v("Correct! Now, determine the uncertainty value for the measurement.")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.firstWrong === true),
        expression: "firstWrong === true"
      }]
    }, [_vm._v("Incorrect! But, you can still earn a point by determining the uncertainty value for the correct measurement.")])]), _vm._v(" "), _c('div', {
      staticClass: "uncertainty-guess"
    }, [_c('span', [_vm._v(_vm._s(q.volume))]), _vm._v(" "), _c('span', {
      staticClass: "porm"
    }, [_vm._v("±")]), _vm._v(" "), _c('span', {
      staticClass: "input"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.guessUncertainty[index]),
        expression: "guessUncertainty[index]"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.01",
        "name": "guessUncertainty[]",
        "autocomplete": "off",
        "value": "0.00"
      },
      domProps: {
        "value": (_vm.guessUncertainty[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.guessUncertainty, index, $event.target.value)
        }
      }
    }), _c('span', [_vm._v("mL")])])]), _vm._v(" "), _c('button', {
      staticClass: "guess btn",
      on: {
        "click": _vm.submitUncertainty
      }
    }, [_vm._v("Submit Uncertainty")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.finalStep === true),
        expression: "finalStep === true"
      }],
      staticClass: "guesses"
    }, [_c('p', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.secondWrong === false),
        expression: "secondWrong === false"
      }]
    }, [_vm._v("Correct!")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.secondWrong === true),
        expression: "secondWrong === true"
      }]
    }, [_vm._v("Incorrect! The uncertainty value is half of the distance between the markings indicated on the graduated cylinder")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.secondWrong === false),
        expression: "secondWrong === false"
      }]
    }, [_c('div', {
      staticClass: "big"
    }, [_vm._v(_vm._s(q.volume) + "mL ± " + _vm._s(q.uncertainty) + "mL")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.secondWrong === true),
        expression: "secondWrong === true"
      }]
    }, [_c('div', {
      staticClass: "uncertainty-guess"
    }, [_c('span', [_vm._v(_vm._s(q.volume))]), _vm._v(" "), _c('span', {
      staticClass: "porm"
    }, [_vm._v("±")]), _vm._v(" "), _c('span', {
      staticClass: "input wrong"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.guessUncertainty[index]),
        expression: "guessUncertainty[index]"
      }],
      attrs: {
        "disabled": "",
        "type": "number",
        "name": "guessUncertainty[]",
        "autocomplete": "off"
      },
      domProps: {
        "value": (_vm.guessUncertainty[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.guessUncertainty, index, $event.target.value)
        }
      }
    }), _c('span', [_vm._v("mL")])])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentQindex + 1 === _vm.totalQuestions),
        expression: "currentQindex+1 === totalQuestions"
      }]
    }, [_c('button', {
      staticClass: "guess btn final",
      on: {
        "click": _vm.nextQuestion
      }
    }, [_vm._v("Continue "), _c('span', [_vm._v("→")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.currentQindex + 1 < _vm.totalQuestions),
        expression: "currentQindex+1 < totalQuestions"
      }]
    }, [_c('button', {
      staticClass: "guess btn final",
      on: {
        "click": _vm.nextQuestion
      }
    }, [_vm._v("Next Question "), _c('span', [_vm._v("→")])])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex === _vm.totalQuestions),
      expression: "currentQindex === totalQuestions"
    }],
    staticClass: "outro"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "outro-inner"
  }, [_c('h1', [_vm._v("You completed the quiz!")]), _vm._v(" "), _c('p', [_vm._v("Your final score was "), _c('span', [_vm._v(_vm._s(_vm.currentScore))]), _vm._v(" / " + _vm._s(_vm.totalQuestions * 2) + ". If you scored...")]), _vm._v(" "), _c('ul', [_c('li', {
    class: _vm.currentScore < 13 ? 'scored' : ''
  }, [_vm._v("0–12 points: having a bad day? Ask your teacher for help.")]), _vm._v(" "), _c('li', {
    class: _vm.currentScore >= 13 && _vm.currentScore <= 16 ? 'scored' : ''
  }, [_vm._v("13–16 points: not bad! If you need more practice, try taking the quiz again.")]), _vm._v(" "), _c('li', {
    class: _vm.currentScore > 16 ? 'scored' : ''
  }, [_vm._v("17–20 points: great job! You have great measurement skills.")])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "id": "reset"
    },
    on: {
      "click": _vm.resetEverything
    }
  }, [_vm._v("Start over")])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === false),
      expression: "startedQuiz === false"
    }],
    key: "intro",
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-inner"
  }, [_c('h1', [_vm._v("Measuring Volume Quiz")]), _vm._v(" "), _c('p', [_vm._v("Select the most accurate volume based on the graduated cylinder shown. Then, consider the markings on the cylinder to determine the uncertainty value for the measurement.")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.startedQuiz = true
      }
    }
  }, [_vm._v("Begin Quiz")])])]), _vm._v(" "), _c('quiz', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === true),
      expression: "startedQuiz === true"
    }],
    key: "quizComponent",
    attrs: {
      "questions": _vm.questions
    },
    on: {
      "restartQuiz": function($event) {
        _vm.startedQuiz = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ })
],[3]);


// WEBPACK FOOTER //
// static/js/app.735e25f71064f5ac62ee.js